import { Dimensions } from 'react-native';
import { isMobile } from './util/BrowserChecker';

const { width, height } = Dimensions.get('window');

// Mobile base size: iPhone 6
const guidelineBaseWidth = isMobile() ? 375 : 1920;
const guidelineBaseHeight = isMobile() ? 667 : 1080;
const screenSize = Math.sqrt(width * height) / 100;

const scale = (size: number) => (width / guidelineBaseWidth) * size;
const verticalScale = (size: number) => (height / guidelineBaseHeight) * size;
const moderateScale = (size: number, factor = 0.5) => size + (scale(size) - size) * factor;

export { scale, verticalScale, moderateScale, screenSize };
/**
 * An object containing the shared fonts used throughout the apps.
 */
export const fonts = {
  descriptionText: {
    fontFamily: 'MontserratRegular',
    fontSize: scale(12),
    fontWeight: undefined,
  },
  header1: {
    fontFamily: 'MontserratBold',
    fontSize: scale(20),
    fontWeight: undefined,
  },
  header2: {
    fontFamily: 'MontserratSemiBold',
    fontSize: scale(16),
    fontWeight: undefined,
  },
  linkedText: {
    fontFamily: 'MontserratSemiBold',
    fontSize: scale(14),
    fontWeight: undefined,
  },
  paragraph: {
    fontFamily: 'MontserratRegular',
    fontSize: scale(14),
    fontWeight: undefined,
  },
  smallBold: {
    fontFamily: 'MontserratSemiBold',
    fontSize: scale(10),
    fontWeight: undefined,
  },
};

/**
 * An object containing the apps' color pallette.
 *
 * Note: These MUST be defined as hex strings, as below, to preserve correct behavior
 * for some custom platform-specific code.
 */
export const colors = {
  languageArts: '#222E83',
  languageArtsLight: '#8895C0',
  health: '#F67E4B',
  healthLight: '#EEC2AA',
  socialStudies: '#3B7A45',
  socialStudiesLight: '#90BDA0',
  science: '#B72E25',
  scienceLight: '#D68D8B',
  math: '#ECB43B',
  mathLight: '#F5D397',
  pe: '#54D6BD',
  peLight: '#BFEFE6',
  arts: '#9C4A95',
  artsLight: '#C69FC5',
  electives: '#7486C4',
  electivesLight: '#E5E8F8',

  black: '#000000',
  blueLight: '#8794C0',
  blueGray: '#ACBAD5',
  grayLight: '#F7F7F7',
  grayDark: '#A4A4A4',
  pinkDark: '#EAB1B2',
  pinkLight: '#F6D2C3',
  purpleLight: '#C49EC3',
  white: '#FFFFFF',
  yellowLight: '#F4D295',
};

/**
 * An object containing the shared device dimensions throughout the app
 * The values are in pixels.
 */
export const dimensions = {
  WEB_MAX_CONTAINER_WIDTH: 476,
};
